import { normalizeFiscalCategory } from './fiscalCategory'

export const RETENUE_REGIME_REEL = 0.03
export const RETENUE_REGIME_FORFAITAIRE = 0.01

export const getDefaultRetenueForCategory = (fiscalCategory) => {
  const cat = normalizeFiscalCategory(fiscalCategory)
  if (cat === 'regime_forfaitaire') return RETENUE_REGIME_FORFAITAIRE
  if (cat === 'regime_reel') return RETENUE_REGIME_REEL
  return RETENUE_REGIME_REEL
}

export const normalizeCoachRetenue = (value, fiscalCategory) => {
  const num = Number(value)
  if (num === RETENUE_REGIME_FORFAITAIRE || num === RETENUE_REGIME_REEL) return num
  return getDefaultRetenueForCategory(fiscalCategory)
}

export const RETENUE_OPTIONS = [
  { value: RETENUE_REGIME_REEL, label: '3 % (régime réel)' },
  { value: RETENUE_REGIME_FORFAITAIRE, label: '1 % (régime forfaitaire)' },
]

export const formatRetenueLabel = (value) => {
  const rate = Number(value)
  if (rate === RETENUE_REGIME_FORFAITAIRE) return '1 %'
  if (rate === RETENUE_REGIME_REEL) return '3 %'
  return `${Math.round(rate * 100)} %`
}

export const applyFiscalCategoryToForm = (form, fiscalCategory) => ({
  ...form,
  fiscalCategory,
  retenue: getDefaultRetenueForCategory(fiscalCategory),
})
